import {Component, h, Host, Listen, Prop } from "@stencil/core";
import "@bun-ui/modals";
import { _debug } from "./debugger/debugger";

export type FormrendererMessageType = 'log' | 'alert' | 'error';
export type FlashMessageType = 'info' | 'alert' | 'error';

export interface FormrendererMessage {
    text: string;
    okBtnLabel: string;
    type: FormrendererMessageType;
}

@Component({
    tag: "formrenderer-flashmessage",
    shadow: true,
})
export class FormrendererFlashmessage {

    @Prop({mutable: true}) text: string
    @Prop({mutable: true}) type: FlashMessageType

    @Listen('formrenderer-message', {target: 'window'})
    showDialog(ev: CustomEvent) {
        const message: FormrendererMessage = ev.detail
        _debug('message', message)
      if(message){
        this.text = message.text

        if(message.type === 'log') {
            this.type = 'info'
        } else {
            this.type = message.type;
        }
      }
    }

    componentDidLoad() {
        // replace Veams flash message behaviour
        window['Veams'] = {};
        window['Veams']['EVENTS'] = {}
        window['Veams']['EVENTS']['flashMessage'] = {}
        window['Veams']['EVENTS']['flashMessage']['show'] = true
        window['Veams']['Vent'] = {};
        window['Veams']['Vent']['trigger'] = (param1, data) => {
            _debug('in replacement Veams vent trigger');
            _debug(param1);
            _debug(data);
            const event = new CustomEvent('formrenderer-message', { detail: data });
            window.dispatchEvent(event);
        };

    }

    render() {
        return (
            <Host>
              <c-modal
                    visible={this.text?.length > 1}
                    flash
                    containerstyle={ this.type }
                    onClose={() => (this.text = null)}
                >
                   <p slot="content">{ this.text }</p>
                </c-modal>
            </Host>
        );
    }
}